import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Button from '../common/Button';
import Spinner from '../common/Spinner';

const TransactionReport = () => {
  const [filter, setFilter] = useState('daily');
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/owner/transactions?filter=${filter}`)
      .then(res => setTransactions(res.data))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="glass-card fade-in">
      <h2>Transaction Report</h2>
      <div className="filter-bar">
        {['daily','weekly','monthly','yearly'].map(f => (
          <Button
            key={f}
            variant={filter === f ? 'primary' : 'outline'}
            onClick={() => setFilter(f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </Button>
        ))}
      </div>
      {loading ? <Spinner /> : (
        <table className="report-table">
          <thead>
            <tr>
              <th>Trip ID</th><th>Vehicle</th><th>Mashell</th><th>Amount</th><th>Status</th><th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map(tx => (
              <tr key={`${tx.trip_id}-${tx.created_at}`}>
                <td>{tx.trip_id}</td>
                <td>{tx.plate_number}</td>
                <td>{tx.mashell_name}</td>
                <td>${tx.amount}</td>
                <td><span className={`status-badge status-${tx.status}`}>{tx.status}</span></td>
                <td>{new Date(tx.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <style>{`
        .filter-bar {
          display: flex; gap: 0.5rem; margin: 1rem 0;
          flex-wrap: wrap;
        }
        .report-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 1rem;
        }
        .report-table th, .report-table td {
          padding: 0.75rem;
          text-align: left;
          border-bottom: 1px solid var(--border);
        }
        .report-table th {
          font-weight: 600; color: var(--text-secondary);
        }
      `}</style>
    </div>
  );
};
export default TransactionReport;